import * as v from 'valibot';
import { EmailAddress } from './credentials.js';
import { identifier, pii } from './domain-string.js';
import { Time, Weekday } from './shared.js';
export const TeacherName = pii('teacher-name');
export const ProfileId = identifier('profile-id');
export const TeacherAvailability = v.picklist([
    'available',
    'ifNeeded',
    'unavailable',
]);
export const TeacherPreferenceSlot = v.object({
    weekday: Weekday,
    startTime: Time,
    endTime: Time,
    selection: TeacherAvailability,
});
export const IfNeededThreshold = v.picklist([
    'perfect',
    'works',
    'neutral',
    'fitOnly',
]);
/** Length of the gap the solver tries to leave between consecutive lessons. */
export const BREAK_MINUTES = 15;
export const BreakPreference = v.picklist([
    'none',
    'whenFree',
    'preferred',
    'always',
]);
export const AvailabilityConfig = v.object({
    startTime: Time,
    endTime: Time,
    preferences: v.array(TeacherPreferenceSlot),
    ifNeededThreshold: v.optional(IfNeededThreshold, 'neutral'),
    // Defaulted so documents and payloads predating breaks still parse.
    breakPreference: v.optional(BreakPreference, 'none'),
});
export const SubscriptionInfo = v.object({
    hasEverHadSubscription: v.optional(v.nullable(v.boolean()), null),
    studentLimit: v.optional(v.nullable(v.number()), null),
});
export const EmailChange = v.object({
    newEmail: EmailAddress,
    oldEmailConfirmed: v.boolean(),
    newEmailConfirmed: v.boolean(),
});
export const CredentialType = v.picklist(['password', 'google']);
export const Profile = v.object({
    id: ProfileId,
    name: TeacherName,
    email: EmailAddress,
    currentScheduleId: v.nullable(identifier('schedule-id')),
    availabilityConfig: AvailabilityConfig,
    subscriptionInfo: v.optional(v.nullable(SubscriptionInfo), null),
    emailChange: v.optional(v.nullable(EmailChange), null),
    // Both credential keys are always present (as the enum-keyed Zod record
    // enforced), so this is an object with required keys, not a partial record.
    credentials: v.object({
        password: v.boolean(),
        google: v.boolean(),
    }),
});
//# sourceMappingURL=profile.js.map